/* eslint-disable camelcase */
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { maskPN } from '@axa-asia/hk-emma-web-module/lib/ga-lib/MaskingUtil';
import TagManager from 'react-gtm-module';
import config from '../config';
import getAxaIdByToken from '../utils/token';
import {
  setDisplayedButtonText,
  getDisplayedButtonText,
} from '../utils/GaPreviousScreenUtil';
import {
  trackAddPolicyFailed,
  trackCtaButton,
  trackDefaultPageViewGA4,
} from './firebaseAnalyticsEvents';
import { getScreenName } from '@axa-asia/ga-tracker';
import { gaScreenNameMapping } from '../constants/gaScreenNameMapping';

export function sendGAEvent(category, action) {
  try {
    if (config.isApp) {
      const tagManagerArgs = {
        gtmId: config.googleTagManagerID,
        events: {
          event: action,
        },
      };
      TagManager.initialize(tagManagerArgs);
    } else {
      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // const { tC } = window;
      // tC.event[action](window, {});
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function sendGA({ event, verificationType }) {
  try {
    if (config.isApp) {
      const tagManagerArgs = {
        gtmId: config.googleTagManagerID,
        events: {
          event: event,
          ...(verificationType ? { verificationType: verificationType } : {}),
        },
      };
      TagManager.initialize(tagManagerArgs);
    } else {
      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // const { tC } = window;
      // tC.event[event](window, {
      //   verificationType,
      // });
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        verificationType: verificationType,
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function policyFailScreen(event, policyFailMsg, userId) {
  try {
    if (config.isApp) {
      // App GA3
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        policyFailMsg: policyFailMsg,
        userId,
      });

      // App GA4
      trackAddPolicyFailed(policyFailMsg);
    } else {
      // Web GA4
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        policyFailMsg: policyFailMsg,
        userId,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // Web GA3
      // const { tC } = window;
      // tC.event.policyAddFail(window, {
      //   policyFailMsg,
      //   'AXAID': userId,
      // });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function confirmationLink(event, verificationType) {
  try {
    if (config.isApp) {
      // App GA3
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        verificationType: verificationType,
      });
    } else {
      // Web GA4
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        verificationType: verificationType,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // Web GA3
      // const { tC } = window;
      // tC.event[event](window, {
      //   verificationType,
      // });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function resetPassword(event, verificationType) {
  try {
    if (config.isApp) {
      // App GA3
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        verificationType: verificationType,
      });
    } else {
      // Web GA4
      const { dataLayer } = window;
      dataLayer.push({
        event: event,
        verificationType: verificationType,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // Web GA3
      // const { tC } = window;
      // tC.event[event](window, {
      //   verificationType,
      // });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function pushDataLayer(
  event,
  verificationType,
  policyFailMsg,
  screenPath,
) {
  try {
    // App GA3, Web GA4
    const { dataLayer } = window;
    const obj = {};
    if (event) {
      obj.event = event;
    }
    if (verificationType) {
      obj.verificationType = verificationType;
    }
    if (policyFailMsg) {
      obj.policyFailMsg = policyFailMsg;
    }
    // dataLayer.push(obj);

    !screenPath
      ? dataLayer.push(obj)
      : getScreenName(screenPath, gaScreenNameMapping).then(
          (mappedScreenName) => {
            dataLayer.push({
              screenName: maskPN(mappedScreenName),
              ...obj,
            });
          },
        );

    // HKEMMA-100917 - GA3 Decommission - Remove GA3
    // if (!config.isApp) {
    //   // Web GA3
    //   const { tC } = window;
    //   tC.event[event](window, {
    //     verificationType,
    //     policyFailMsg,
    //   });
    // }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

// KPI #62 - GA tagging for all CTA button/tab/link text
export function clickCTAButton(event, displayedButtonText, screenName, userId) {
  if (config.isApp) {
    // App GA3
    const { dataLayer } = window;
    dataLayer.push({
      event,
      displayedButtonText,
      screenName: maskPN(screenName),
      userId,
    });

    // App GA4
    trackCtaButton(displayedButtonText, screenName);
  } else {
    // Web GA4
    const { dataLayer } = window;
    dataLayer.push({
      event,
      displayedButtonText,
      screenName: maskPN(screenName),
      userId,
    });

    // HKEMMA-100917 - GA3 Decommission - Remove GA3
    // Web GA3
    // const { tC } = window;
    // tC.event.clickCTAButton(window, {
    //   displayedButtonText,
    //   screenName,
    //   'AXAID': userId,
    // });
  }
}

// KPI #64 - tracking previous screen
export function trackPreviousScreen(
  event,
  displayedButtonText,
  previousScreenName,
  screenName,
  userId,
) {
  if (!config.isApp) {
    // HKEMMA-100917 - GA3 Decommission - Remove GA3
    // Web GA3
    // const { tC } = window;
    // tC.event[event](this, {
    //   'event': event,
    //   'displayedButtonText': displayedButtonText,
    //   'previousScreenName': previousScreenName,
    //   'screenName': screenName,
    //   'AXAID': userId,
    // });

    // Web GA4
    const { dataLayer } = window;
    dataLayer.push({
      event,
      displayedButtonText,
      previousScreenName: maskPN(previousScreenName),
      // screenName: maskPN(screenName),
      userId,
    });
  } else {
    // App GA3
    const { dataLayer } = window;
    dataLayer.push({
      event,
      displayedButtonText,
      previousScreenName: maskPN(previousScreenName),
      // screenName: maskPN(screenName),
      userId,
    });
  }
}

// GA callback for clickable elements
export const gaClickableElementCallback = (
  event,
  displayedButtonText,
  screenName,
) => {
  setDisplayedButtonText(displayedButtonText);
  try {
    // Retrieve axaid and the axaid must be accessed by the callback
    const token = sessionStorage.getItem('token') || '';
    const axaId = getAxaIdByToken(token);
    // TODO: different event use diff function
    if (event === 'clickCTAButton') {
      clickCTAButton(event, displayedButtonText, screenName, axaId);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};

/**
 * #0 default page view
 * It must use the exact URL instead of screen name
 */
export function trackDefaultPageView(currentUrl = '') {
  try {
    const spaCurrentUrl = `SPA:${currentUrl}`;
    const token = sessionStorage.getItem('token') || '';
    const axaId = getAxaIdByToken(token);
    const changeCurrentUrl = spaCurrentUrl.replace(/(\/)$/, '');
    if (config.isApp) {
      // App GA3
      const { dataLayer } = window;
      dataLayer.push({
        event: 'screenView',
        page: maskPN(changeCurrentUrl),
      });
    } else {
      // Web GA4
      const { dataLayer } = window;
      dataLayer.push({
        event: 'screenView',
        page: changeCurrentUrl,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // // Web GA3
      // const { tC } = window;
      // tC.event.virtualPageview(this, {
      //   'page': changeCurrentUrl,
      //   'AXAID': axaId,
      // });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.info(error);
  }
}

export const logPreviousUrlCallback = (
  previousScreenName,
  currentScreenName,
  currentScreenPath,
) => {
  try {
    // Retrieve axaid and the axaid must be accessed by the callback
    const token = sessionStorage.getItem('token') || '';
    const axaId = getAxaIdByToken(token);
    const eventName = 'previousScreen';
    // Deal with the browser button click case
    if (window.event && window.event.type === 'popstate') {
      setDisplayedButtonText('Back / Forward');
    }

    // Track popup display to trigger page view
    if (currentScreenPath.includes('#') || previousScreenName.includes('#')) {
      trackDefaultPageView(currentScreenPath);
    }

    const displayedButtonText = getDisplayedButtonText();

    // GA3
    trackPreviousScreen(
      eventName,
      displayedButtonText,
      previousScreenName,
      currentScreenName,
      axaId,
    );

    // GA4
    trackDefaultPageViewGA4(
      currentScreenName,
      previousScreenName,
      currentScreenPath,
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.info(error);
  }
};

/**
 * Send experiment ids to GA3 and GA4
 * Format: <experimentId>:<variantId>,<experimentId>:<variantId>,...
 * For example: ABC:0,DEF:1,HIJ:0
 * @param {*} experimentIds
 */
export const setupExperimentIdsToDataLayer = (experimentIds) => {
  try {
    // App GA3, Web GA4
    const { dataLayer } = window;
    dataLayer.push({ experimentIds });

    // TODO - GA3 (Allen)
    if (!config.isApp) {
      window.tc_vars.experimentIds = experimentIds;
    }
  } catch (e) {
    console.error(e);
  }
};
